<div  class="main-contact">
    <p-tabView>
        <p-tabPanel header="contacts" i18n-header="@@contacts">
            <div class="card">
                <div class="col-12">
                    <input style="width: 100%" placeholder="Search" (keyup.enter)="loadListContact(dt)">
                </div>
                <p-table #dt
                         [value]="listContact"
                         [paginator]="true"
                         [rows]="10"
                         [totalRecords]="totalContact"
                         [lazy]="true"
                         (onLazyLoad)="loadListContact(dt)"
                         [showCurrentPageReport]="true"
                         [tableStyle]="{ 'min-width': '50rem' }"
                         [currentPageReportTemplate]="farsitableTemplate(dt.first,totalContact)"

                         [paginatorLocale]="locale=='fa'?'fa-IR':''"
                >
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width:25%" i18n="@@name">name</th>
                            <th style="width:25%" i18n="@@lastname">lastname</th>
                            <th style="width:25%" i18n="@@subject">subject</th>
                            <th style="width:25%"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-contact>
                        <tr style="{{contact.read ==false ?'background-color: #e9f7eb;' :''}}">
                            <td>{{ contact.firstName }}</td>
                            <td>{{contact.lastName }}</td>
                            <td>{{ contact.subject }}</td>
                            <td>
                                <div class="operation-icons">
                                    <i class="pi pi-trash" (click)="deleteContact(contact,dt)"></i>
                                    <i class="pi pi-eye" (click)="showDetContact(contact)"></i>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="paginatorleft">
                    </ng-template>
                    <ng-template pTemplate="paginatorright">
                    </ng-template>
                </p-table>
            </div>
        </p-tabPanel>
        <p-tabPanel header="Contact Us" i18n-header="@@Contact Us">
            <div class="col-12">
                <div class="col-12">
                    <label i18n="@@Description">Description</label>:
                    <textarea style="width: 100%;" [(ngModel)]="contactSetting.desc"></textarea>
                </div>
                <div class="col-12">
                    <label i18n="@@Address">Address</label>:
                    <textarea style="width: 100%;"  [(ngModel)]="contactSetting.address"></textarea>
                </div>
                <div class="col-12">
                    <label i18n="@@Email">Email</label>
                    <input style="width: 100%;"  [(ngModel)]="contactSetting.email">
                </div>
                <div class="col-12">
                    <label i18n="@@Phone">Phone</label>
                    <input style="width: 100%;"  [(ngModel)]="contactSetting.phone">
                </div>
                <div class="col-12">
                    <label i18n="@@Form Description">Form Description</label>:
                    <textarea style="width: 100%;"  [(ngModel)]="contactSetting.formDesc"></textarea>
                </div>
                <div class="col-12">
                    <button  class="button darkblue" (click)=" saveContactSetting()">
                        <span i18n="@@Save">Save</span>
                    </button>
                </div>

            </div>

        </p-tabPanel>
    </p-tabView>

</div>

<p-dialog i18n-header="@@Image Manager" header="Image Manager" [resizable]="false"
          [(visible)]="displayDetContact"
          showEffect="fade" [modal]="true" [closable]="true" [style]="{'width':'90%'}">

        <div class="col-12 flex flex-wrap formdiv">
            <div class="col-12 md:col-6 lg:col-4">
                <label i18n="@@name">name</label>:
                <span>{{selectedContact.firstName}}</span>
            </div>
            <div class="col-12 md:col-6 lg:col-4">
                <label i18n="@@lastname">lastname</label>:
                <span> {{selectedContact.lastName}}</span>
            </div>
            <div class="col-12 md:col-6 lg:col-4">
                <label i18n="@@Organizational email">Organizational email</label>:
                <span> {{selectedContact.email}}</span>
            </div>
            <div class="col-12 md:col-6 lg:col-4">
                <label i18n="@@Mobile Number">Mobile Number</label>:
                <span>{{selectedContact.mobile}}</span>
            </div>
            <div class="col-12 md:col-6 lg:col-4">
                <label i18n="@@organization level">organization level</label>:
                <span>{{selectedContact.rol}}</span>
            </div>


            <div class="col-12 ">
                <label  i18n="@@subject">subject</label>:
                <span >{{selectedContact.subject}}</span>
            </div>
            <div class="col-12">
                <label i18n="@@Text">Text</label>:
                <p >{{selectedContact.text}}</p>
            </div>

        </div>


</p-dialog>